// extracted by mini-css-extract-plugin
export default {"pRight":"Subscription_pRight__+Ft9C","pDetailsField":"Subscription_pDetailsField__22mq3","pButtonR":"Subscription_pButtonR__lGAKL","pbuttons":"Subscription_pbuttons__I9n0G"};